import type {
	PortfolioDetailResponseDTO,
	PropertyInsuranceDetailDataDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { NON_LIFE_INSURANCE_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/nonLifeInsuranceFormDefaults";
import type { NonLifeInsuranceFormInput } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/nonLifeInsuranceFormSchema";

export const mapPortfolioToNonLifeInsuranceForm = (
	portfolio: PortfolioDetailResponseDTO,
): NonLifeInsuranceFormInput => {
	const data = portfolio.data as PropertyInsuranceDetailDataDTO | undefined;

	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		insurance: data?.insurance ?? DEFAULTS.insurance,
		insurancePeriod: data?.insurancePeriod ?? DEFAULTS.insurancePeriod,
		paymentFrequency: data?.paymentFrequency ?? DEFAULTS.paymentFrequency,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
	};
};
